export default "__VITE_ASSET__BOcldkvP__"